module.exports = __webpack_public_path__ + "static/media/inheritance.a499509e.svg";